import invariant from 'tiny-invariant'

import type { paths } from '@luxuryescapes/contract-svc-accommodation'

type ServerCalendarPrices = paths['/api/accommodation/properties/{propertyId}/calendar-prices']['get']
// Unfortunately, the following type isn't defined under `definitions`.
type ServerCalendarPricesResponseResult = ServerCalendarPrices['responses']['200']['content']['application/json']['result']

export default function mapPropertyCalendarPrices({
  // propertyId, // This is unused.
  los,
  currency,
  // occupancies, // This is unused.
  months,
}: ServerCalendarPricesResponseResult, isDynamicFlash: boolean): { [isoDate: string]: App.Property.CalendarDay } {
  return Object.fromEntries(months.flatMap(({
    year,
    month,
    days,
  }) => {
    invariant(year >= 2026 && year <= 9999 && month >= 1 && month <= 12)
    const isoYearMonth = `${year}-${String(month).padStart(2, '0')}`

    return Object.entries(days).map(([day, calendarDayPrice]): [string, App.Property.CalendarDay] => {
      // We don't care about specifics (like how February has 28 days).
      invariant(Number(day) >= 1 && Number(day) <= 31)
      const isoDate = `${isoYearMonth}-${day.padStart(2, '0')}`

      // Realistically, we won't have LuxPlus+ prices without also having non-LuxPlus+ prices.
      // A day that the service omits gets no entry (its availability is unknown), whereas a day
      // without a price is sold out.
      const displayPrice = isDynamicFlash ? calendarDayPrice?.campaignPrice : calendarDayPrice?.publicPrice
      if (!displayPrice) {
        return [isoDate, {
          isoDate,
          type: 'unavailable',
          duration: los,
          currency,
        }]
      }

      return [isoDate, {
        isoDate,
        type: 'available',
        duration: los,
        currency,
        displayPrice,
        luxPlusDisplayPrice: isDynamicFlash ? calendarDayPrice?.campaignLuxPlusPrice : calendarDayPrice?.luxPlusPrice,
      }]
    })
  }))
}
